<template>
  <div class="dashboard">
    <top-header></top-header>
    <b-container  class="mb-4" style="margin-top:4%">
      <b-row>
        <b-col class="px-0">
          
          <b-img v-bind="mainProps"  src="https://www.alluraa.com/media/images/banner-sales-advisor.png" fluid></b-img>
         <!-- <b-img v-if="customer.role == TYPE_ADVICER" v-bind="mainProps" class="d-block d-sm-none" src="https://www.alluraa.com/media/images/banner-sales-advisor-mobile.jpg" fluid></b-img> -->
        </b-col>
      </b-row>
    </b-container>
	
	
    <b-container class="mb-3 bginflucer" >
	<b-row class="infrow">
		<b-col lg="5" md="5" sm="12" class="px-2 text-left ">
			<b-img src="../assets/influencer/Influencer-page.gif" fluid alt="placeholder" class="img1st"></b-img>
		</b-col>
		<b-col cols="12" lg="7" md="7" sm="12" class="px-2 text-center infcontet">
			<!--<p class="inftitle"> Create</p> -->
			<h2 class="inftitle"> Create your profile</h2>
			<ul>
				<li>Simply Add Products to</li>
				<li>your profile & manage</li>
				<li>just like a shop</li>
				
			</ul>
			
		</b-col>
	 </b-row>
	 <b-row class="infrow">
		
		<b-col lg="6" md="6" sm="12" class="px-2 text-left d-block d-sm-none">
			<b-img src="../assets/influencer/Alluraa-Influencer-Tile-02.png" alt="placeholder" class="img2nd"></b-img>
		</b-col>
		<b-col cols="12" lg="6" md="6" sm="12" class="px-2 text-center infcontet2d">
			<h2 class="inftitle"> Talk about Products</h2>
			<ul>
				<li>Create and Post</li>
				<li>Images Reels & Videos </li>
				<li> of Products on Social Platforms</li>
				
			</ul>
			
		</b-col>
		<b-col lg="6" md="6" sm="12" class="px-2 text-left d-none d-md-block ">
			<b-img src="../assets/influencer/Alluraa-Influencer-Tile-02.png" alt="placeholder" class="img2nd"></b-img>
		</b-col>
	 </b-row>
	 <b-row class="infrows" style="margin:40px 0px;">
		<b-col lg="5" md="5" sm="12" class="px-2 text-left">
			<b-img src="../assets/influencer/Alluraa-Influencer-Tile-041.png"  alt="placeholder" class="img3rd"></b-img>
		</b-col>
		<b-col cols="12" lg="7" md="7" sm="12" class="px-2 text-center  infcontet">
			<h2 class="inftitle"> share products</h2> 
			<ul>
				<li>Share the product</li>
				<li>listed on the site with</li>
				<li>your Contacts/Followers.</li>
				
			</ul>
			
		</b-col>
	 </b-row>
	 
	 <b-row class="infrow">
		
		<b-col lg="6" md="6" sm="12" class="px-2 text-left d-block d-sm-none">
			<b-img src="../assets/influencer/Alluraa-Influencer-Tile-03.png" alt="placeholder" class="img4rd"></b-img>
		</b-col>
		<b-col cols="12" lg="6" md="6" sm="12" class="px-2 text-center infcontet2d">
			<h2 class="inftitle">Earn on every sale</h2>
			<ul>
				<li>Get profit margins & bonuses</li> 
				<li>directly to your bank</li>
				<li>account regularly</li>
				
			</ul>
			
		</b-col>
		<b-col lg="6" md="6" sm="12" class="px-2 text-left d-none d-md-block ">
			<b-img src="../assets/influencer/Alluraa-Influencer-Tile-03.png" alt="placeholder" class="img4rd"></b-img>
		</b-col>
	 </b-row>
	 
	 
		<b-row class="pt-3">
			<b-col lg="6" sm="12" class="infbtnl" >
				 <b-button href="/register/influencer" variant="primary" class="mr-2 btn-solid submitlogin " style="width: 273px; border-radius: 0px;text-transform: uppercase;">Become an Influencer</b-button>			
			</b-col>
			<b-col lg="6" sm="12" class="infbtnlTraning"  >
				 <b-button href="/training" variant="primary" class="mr-2 btn-solid submitlogin " style="width: 273px; border-radius: 0px;text-transform: uppercase;">Influencer Training</b-button>			
			</b-col>
		</b-row>
		
		
		
	
	</b-container>
	
    <bottom-footer></bottom-footer>
   <!-- <b-modal id="modal-status" hide-footer>
      <template v-slot:modal-title>
        Status
      </template>
      <div class="d-block text-center">
        <h5>{{modal.msg}}</h5>
      </div>
      <b-link class="mt-3 button btn-solid float-right" @click="$bvModal.hide('modal-status')">Close Me</b-link>
    </b-modal> -->

    
  </div>
</template>

<script>

import Header from "@/components/header.vue";
/* import Footer from "@/components/footer-promo.vue"; */
import Footer from "@/components/footer.vue";
//import InstagramSwiper from "@/components/instagram-swiper.vue";

export default {
  name: "Home",
  beforeCreate: function() {
      document.body.className = 'promo';
  },
  components: {
    "top-header": Header,
    "bottom-footer": Footer,
	//"instagram-swiper": InstagramSwiper,
  },
  data() {
    return {  
      TYPE_ADVICER: 'sales-advisor',
      mainProps: { fluidGrow: true, class: 'm1' },
    }
  },
  methods: {
    
   
  },
	metaInfo() {
		return{
			title: 'Influencer | Alluraa',
			titleTemplate: null, //'%s | vue-meta Example App',
			meta: [
				{ charset: 'utf-8' },
				{ name: 'keywords', content: 'Alluraa, Influencer' },
				{ name: 'description', content: 'Influencer | Alluraa' },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' },
				{ name:'p:domain_verify', content: '2414d644d27428df1547004055b7bcb0' }
				
			]
		}
	}
};
</script>
